import React from "react";
import {
  Select,
  MenuItem,
  Grid
} from "@material-ui/core";
import { format } from "date-fns";

import SreoMetricsPillbox from "./SreoMetricsPillbox";
import "./styles.css";

const SreoScreenerHeader = ({
  sponsorCompanies,
  selectedCompany,
  selectedAsOfDate,
  handleCompanyDropdown,
  handleDateDropdown,
  selectedCompanyId,
  dates,
  shouldShowDates,
  numberOfProperties,
  numberOfUnits,
  averageExpenseRatio,
  totalDebt,
  averageDscr,
  averageCapRate,
  averageLtv
}) => {
  const MetricsData = [
    {
      title: "Properties",
      metricValue: numberOfProperties,
      type: "INTEGER"
    },
    {
      title: "Total Units",
      metricValue: numberOfUnits,
      type: "INTEGER"
    },
    {
      title: "Average Expense Ratio",
      metricValue: averageExpenseRatio,
      type: "PERCENT"
    },
    {
      title: "Total Debt",
      metricValue: totalDebt,
      type: "CURRENCY"
    },
    {
      title: "Average DSCR",
      metricValue: averageDscr,
      type: "INTEGER",
      suffix: "x"
    },
    {
      title: "Average Cap Rate",
      metricValue: averageCapRate,
      type: "PERCENT"
    },
    {
      title: "Average LTV",
      metricValue: averageLtv,
      type: "PERCENT"
    }
  ];

  return (
    <Grid container xs={12} direction="column" className="sreo-screener-header-card-wrapper">
      <Grid container item xs={12} direction="row" className="sreo-screener-header-row-1-wrapper">
        <Grid container item xs={7} alignContent="center">
          <div className="sreo-screener-header-title-wrapper">
            <div className="sreo-screener-header-title">
              <span>Schedule of Real Estate Owned</span>
              {selectedAsOfDate && <span>
                (as of
                {selectedAsOfDate}
                )
              </span>}
            </div>
            <div className="sreo-screener-header-company">{selectedCompany}</div>
          </div>
        </Grid>
        <Grid container item xs={5} alignContent="center" className="sreo-screener-header-pickers-wrapper">
          <div className="sreo-screener-header-pickers sreo-screener-date-picker-wrapper">
            {shouldShowDates && <Select
              placeholder="Select an as of Date"
              renderValue={value => (value?.length ? Array.isArray(value) ? value.join(", ") : value : "Select an as of date")}
              displayEmpty
              variant="filled"
              style={{ width: "205px" }}
              value={selectedAsOfDate}
              onChange={event => {
                handleDateDropdown(event.target.value);
              }}
            >
              <MenuItem value="" disabled>Select an as of Date</MenuItem>
              {dates.map((date => <MenuItem value={date}>{date}</MenuItem>))}
                                </Select>}
          </div>
          <div className="sreo-screener-header-pickers">
            {sponsorCompanies && <Select
              placeholder="Select a company"
              renderValue={value => (value ? selectedCompany : "Select a Company")}
              displayEmpty
              variant="filled"
              style={{ width: "205px", marginRight: "55px" }}
              value={selectedCompanyId}
              onChange={event => {
                handleCompanyDropdown(event.target.value);
              }}
            >
              <MenuItem value="">All Companies</MenuItem>
              {sponsorCompanies.map((company => <MenuItem value={company.id}>{company.name}</MenuItem>))}
                                 </Select>}
          </div>
        </Grid>
      </Grid>
      <Grid container item xs={12}>
        <SreoMetricsPillbox metrics={MetricsData} />
      </Grid>
    </Grid>
  );
};

export default SreoScreenerHeader;
